import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import HeadingM from "../../components/shared/HeadingM"
import Layout from "../../components/do/Layout"
import SEO from "../../components/Seo"
import About from "../../components/shared/usage/do-About"
import Fee from "../../components/shared/usage/do-Fee"
import Procedure from "../../components/shared/usage/do-Procedure"
import { PAGE } from "../../constants"

const usage = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.usage} siteTitle="Do" />
      <HeadingL title={PAGE.title.usage} target="do" />
      <HeadingM title="ご利用について" target="do" />
      <About />
      <HeadingM title="ご利用料金" target="do" />
      <Fee target="do" />
      <HeadingM title="ご利用手順" target="do" />
      <Procedure target="do" />
    </Layout>
  )
}

export default usage
